<script setup lang="ts">
import { useMidi } from '../composables/useMidi';
import { useDeviceDetection } from '@/composables/useDeviceDetection';

const { isMobileDevice } = useDeviceDetection();
const { isEnabled, inputs, currentInput, enableMidi, selectInput } = useMidi();

// Handle device selection
const selectDevice = (deviceId: string) => {
  selectInput(deviceId);
};
</script>

<template>
  <div class="bg-surface px-6 rounded-xl w-full grow flex flex-col">
    <h2 class="text-xl font-semibold mb-4 text-text-primary">MIDI Device</h2>

    <div v-if="!isEnabled" class="text-center">
      <p class="text-text-secondary mb-4">MIDI is not enabled or supported</p>
      <button
        class="px-4 py-2 bg-primary text-text-primary rounded-lg hover:bg-opacity-90 transition"
        @click="enableMidi"
      >
        Enable MIDI Access
      </button>
    </div>

    <div v-else-if="inputs.length === 0" class="text-center">
      <p class="text-text-secondary">No MIDI devices detected</p>
      <p class="text-text-primary/50 text-sm mt-2">Please connect a MIDI device and refresh</p>
    </div>

    <div
      v-else
      class="space-y-4 flex flex-col grow"
    >
      <div class="flex items-center justify-between">
        <span class="text-text-secondary">Select MIDI Input Device:</span>
        <span
          class="px-2 py-1 rounded-full text-xs"
          :class="currentInput ? 'bg-primary text-text-primary' : 'bg-danger/20 text-danger'"
        >
          {{ currentInput ? 'Connected' : 'Disconnected' }}
        </span>
      </div>

      <div
        class="space-y-2 overflow-y-scroll p-0.5"
        :class="{'max-h-25': !isMobileDevice}"
      >
        <button
          v-for="input in inputs"
          :key="input.id"
          class="w-full text-left px-4 py-3 rounded-lg transition"
          :class="currentInput?.id === input.id
            ? 'bg-primary text-text-primary'
            : 'bg-surface hover:bg-surface text-text-primary'"
          @click="selectDevice(input.id)"
        >
          {{ input.name }}
        </button>
      </div>
    </div>
  </div>
</template>
